import React, { PropsWithChildren } from "react";

import useAppStore from "../data/store";

const InfoMessage: React.FC<
  PropsWithChildren & {
    title: string;
    style?: React.CSSProperties;
  }
> = (props) => {
  const { title, style, children } = props;
  const brand = useAppStore((state) => state.brand);
  return (
    <div
      style={{
        fontFamily: `${brand === "casa" ? "Anton" : "Open Sans"}`,
        fontWeight: `${brand === "casa" ? "400" : "800"}`,
        fontSize: "36px",
        lineHeight: "54px",
        color: "#212121",
        padding: "8px",
        boxShadow: "white 0px -4px 45px",
        position: "relative",
        borderRadius: "24px",
        background: "white",
        ...style,
      }}
    >
      <div
        style={{
          border: "8px solid #fff",
          padding: "32px",
          minWidth: "500px",
          maxWidth: "100%",
          borderRadius: 20,
          display: "inline-flex",
          justifyContent: "center",
          boxShadow: "rgba(0,0,0,0.05) 0px 0px 50px inset, rgba(0,0,0,0.1) 0px 0px 16px",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            {children !== undefined ? children : title}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoMessage;

/*   <MessageContainer style={{ background: "#212121" }}>
        <ErrorMessage
          title="Eroare"
          subtitle="Problema la verificare "
          onClose={() => {}}
        />
      </MessageContainer>
      */
